import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
// import { ClassicEditor } from 'ckeditor5';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';
import { DmsFile } from '../../modal/upload/model/upload.model';

@Component({
  selector: 'app-upload-drawings',
  standalone: false,
  templateUrl: './upload-drawings.component.html',
  styleUrl: './upload-drawings.component.scss',
})
export class UploadDrawingsComponent implements OnInit, OnDestroy {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  commentForm: FormGroup;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  aonSocForm!: FormGroup;
  selectedFiles: any;
  uploadedAonUrl: string | null = null;
  uploadedSocUrl: string | null = null;
  apiUrl = environment.APIUrl;
  aonID: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('aonUploader') aonUploader: FileUpload;
  @ViewChild('socUploader') scUploader: FileUpload;

  private subscriptions = new Subscription();
  userID: any;
  selectedSOCFileName: string | null = null;
  selectedAONFileName: string | null = null;
  selectedAONFiles: File[] = [];
  selectedSOCFiles: File[] = [];
  drawingFiles: any;
  docuemntdrawingFiles: any;
  allDmsFiles: any[] = [];
  rows: any[]
  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute
  ) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
      // vendor: ['', Validators.required],
      // upload: ['', Validators.required],
      date: ['', Validators.required],
      qap_date: [''],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    // this.loadDocList();
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.aonSocForm = this.fb.group({});
    this.getAonSocDetails();
    if (this.stepDetails?.can_edit) {
      this.commentForm.enable();
    } else {
      this.commentForm.disable();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  onFileSelect(event: any, type: 'aon' | 'soc') {
    const selectedFiles = event.files;
    if (!this.selectedFiles) {
      this.selectedFiles = {};
    }
    // Store files separately for UI display
    if (type === 'aon') {
      this.selectedAONFiles = [...selectedFiles];
      this.selectedFiles['aon'] = [...selectedFiles];
    }
    if (type === 'soc') {
      this.selectedSOCFiles = [...selectedFiles];
      this.selectedFiles['soc'] = [...selectedFiles];
    }
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: `${selectedFiles.length} file(s) attached successfully`,
    });
  }

  onSubmit() {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    let comment = this.commentForm.get('comment').value;
    formData.append('comment', comment);
    formData.append('date', this.commentForm.get('date').value);
    formData.append('qap_date', this.commentForm.get('qap_date').value);

    if (this.selectedFiles?.['aon']) {
      for (const file of this.selectedFiles['aon']) {
        formData.append('drawing_files', file);
      }
    }
    // Append SOC files correctly
    if (this.selectedFiles?.['soc']) {
      for (const file of this.selectedFiles['soc']) {
        formData.append('drawing_additional_files', file);
      }
    }


    const basePath = this.getDrawingBasePath();
    if (this.aonID) {
      const sub = this.api
        .putAPI(`${basePath}${this.aonID}/`, formData)
        .subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Submitted',
              detail: 'Data uploaded successfully',
            });
            // Clear uploaded files if needed
            this.selectedAONFiles = null;
            this.selectedSOCFiles = null;
            this.selectedSOCFileName = '';
            this.selectedAONFileName = '';
            this.aonUploader?.clear();
            this.scUploader?.clear();
            this.getAonSocDetails();
            // this.stepCompleted.emit();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Upload failed',
            });
          },
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api
        .postAPI(basePath, formData)
        .subscribe({
          next: (res) => {
            this.getAonSocDetails();
            this.messageService.add({
              severity: 'success',
              summary: 'Submitted',
              detail: 'Data uploaded successfully',
            });
            // Clear uploaded files if needed
            this.selectedAONFiles = null;
            this.selectedSOCFiles = null;
            this.selectedSOCFileName = '';
            this.selectedAONFileName = '';
            this.aonUploader?.clear();
            this.scUploader?.clear();
            // this.stepCompleted.emit();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Upload failed',
            });
          },
        });
      this.subscriptions.add(sub);
    }
  }
  drawing: any;
  getDrawingBasePath(): string {
    console.log("scheme type is", this.schemeType);
    return this.schemeType === 'makeI' || this.schemeType === 'makeII' || this.schemeType === 'makeIII'
      ? '/make1/drawing/documents/'
      : '/revenue/drawing/documents/';
  }

  getAonSocDetails() {
    const basePath = this.getDrawingBasePath();
    const sub = this.api
      .getAPI(
        `${basePath}?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe({
        next: (res: any) => {
          // this.uploadedAonUrl = res?.drawing || null;
          // this.uploadedSocUrl = res?.document || null;

          console.log('this is upload drawings', res);
          const dmsFiles: DmsFile[] = res.dms_files;
          this.allDmsFiles = dmsFiles;
          this.drawingFiles = res.drawing_files || [];
          this.docuemntdrawingFiles = res.drawing_additional_files || [];
          this.drawing = res.id;
          console.log("this is drawing id", this.drawing);


          // Set SOC files from drawing_additional_files array
          // this.selectedSOCFiles = res.drawing_additional_files || [];

          this.aonID = res?.id;
          this.commentForm.patchValue({
            comment: res.comment,
            date: res.date,
            qap_date: res.qap_date,
          });
          this.rows = (res?.drawing_qap_date || []).map((row: any) => ({
            ...row,
            edit: false
          }));
        },
        error: (err) => { },
      });
    this.subscriptions.add(sub);
  }


  goToNextStep() {
    this.stepCompleted.emit();
  }

  saveRow(row: any) {
    console.log("row is checking",row);
    // let basePost = '/revenue/drawing/qap/dates/';
    // let basePut = '/revenue/drawing/qap/dates/';
    const basePath = `/make1/drawing/qap/dates/`;

    // API selection
    // if (this.stepDetails?.code === 'P_QR') {
    //   basePost = '/make1/preparation/question/query/';
    //   basePut = '/make1/preparation/question/query/';
    // } 
    // else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
    //   basePost = '/make1/pre-eol/query/';
    //   basePut = '/make1/pre-eol/query/';
    // }

    const payload: any = {
      drawing: this.drawing,
      document: row.document,
      submission_date: row.submission_date,
      approval_date: row.approval_date,
      remark: row.remark,
      // applicant_name : row.applicant_name,
      // pre_question: row.pre_question,

    };

    // Foreign key assignment
    // if (this.stepDetails?.code === 'P_QR') {
    //   console.log("prequery id is", this.prequery);
    //   payload.pre_question = this.prequery;
    // } 
    // else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
    //   payload.preeol = this.preeolId;
    // } 
    // else {
    //   payload.prebid = this.rfpdata?.id;
    // }

    const apiCall = row.id
      ? this.api.putAPI(`${basePath}${row.id}/`, payload)
      : this.api.postAPI(basePath, payload);

    const sub = apiCall.subscribe(
      (res: any) => {
        this.getAonSocDetails();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: res.message || 'Record saved successfully'
        });
      },
      (err) => {
        console.error('Error saving row:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            err?.error?.detail ||
            err?.error?.pre_question?.[0] ||
            err?.error?.preeol?.[0] ||
            err?.error?.prebid?.[0] ||
            'Failed to save record'
        });
      }
    );

    this.subscriptions.add(sub);
  }
//   saveRow(row: any) {
//   console.log("row is checking", row);

//   const basePath = `/drawing/qap/dates/`;

//   // const payload: any = {
//   //   drawing: this.drawing,
//   //   document: row.document,
//   //   submission_date: row.submission_date,
//   //   approval_date: row.approval_date,
//   //   remark: row.remark,
//   // };
//   const payload = new FormData();

//   payload.append('drawing', this.drawing);
// payload.append('document', row.document);
// payload.append('submission_date', row.submission_date);
// payload.append('approval_date', row.approval_date);
// payload.append('remark', row.remark);

//   let apiCall;

//   // ✅ Priority 1: If aonID exists → behave like onSubmit
//   if (this.aonID) {
//     apiCall = this.api.putAPI(`${basePath}${this.aonID}/`, payload);
//   } 
//   // ✅ Priority 2: Row edit
//   else if (row.id) {
//     apiCall = this.api.putAPI(`${basePath}${row.id}/`, payload);
//   } 
//   // ✅ Priority 3: New row
//   else {
//     apiCall = this.api.postAPI(basePath, payload);
//   }

//   const sub = apiCall.subscribe(
//     (res: any) => {
//       this.getAonSocDetails();
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: res.message || 'Record saved successfully'
//       });
//     },
//     (err) => {
//       console.error('Error saving row:', err);
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//         detail:
//           err?.error?.detail ||
//           err?.error?.pre_question?.[0] ||
//           err?.error?.preeol?.[0] ||
//           err?.error?.prebid?.[0] ||
//           'Failed to save record'
//       });
//     }
//   );

//   this.subscriptions.add(sub);
// }

  addRow() {
    if (!this.rows) {
      this.rows = [];
    }
    this.rows.push({ document: '', submission_date: '', approval_date: '', remark: '', edit: true });
  }

 


}
